import { createDialog } from '@patsnap/tahiti-core';

export const wireFrameExtractDialogServiceFactory = () => createDialog(() => import('../components/WireFrameExtractDialog.vue'));
